export default __webpack_public_path__ + "static/media/user.bf381801.svg";